module.exports = __webpack_public_path__ + "img/server06.79142d6f.jpg";